<template>
  <Container class="screen-content flex-1 px-0 pb-32">
    <LayoutPageHeader :title="$t('header.page_titles.brand')" />
    <div class="mx-auto max-w-xl px-8">
      <div class="prose prose-a:no-underline prose-h2:text-lg prose-h2:!font-bold prose-p:text-gray-800 !max-w-full">
        <ContentDoc />
      </div>
    </div>
  </Container>
</template>
